// src/App.js
import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { AuthProvider } from "./contexts/AuthContext"; // Add this import
import { CustomThemeProvider } from "./contexts/ThemeContext"; // Add this if you want theme support
import ProtectedRoute from "./components/ProtectedRoute";
import AuthRoute from "./components/AuthRoute";
import PageSkeleton from "./components/PageSkeleton";

/* Lazy Pages */
const Home = lazy(() => import("./pages/home"));
const SignIn = lazy(() => import("./auth/sign-in"));
const ForgotPassword = lazy(() => import("./auth/forgot-password"));
const ResetPassword = lazy(() => import("./auth/reset-password"));
const VerifyEmail = lazy(() => import("./auth/verify-email"));
const Dashboard = lazy(() => import("./dashboard/dashboard"));
const Profile = lazy(() => import("./pages/profile"));
const NotFound = lazy(() => import("./pages/NotFound"));
const UserControl = lazy(() => import("./pages/user-control"));

const CreateQuestionPaper = lazy(() => import('./pages/CreateQuestionPaper'));
const EditQuestionPaper = lazy(() => import('./pages/EditQuestionPaper'));
const QuestionPapers = lazy(() => import('./pages/QuestionPapers'));

const ExamControl  = lazy(() => import("./pages/Exams"));
const AdminCreateExam = lazy(() => import("./pages/CreateExam"));
const AdminExamDetails = lazy(() => import("./pages/ExamDetails"));
const AdminEditExam = lazy(() => import("./pages/EditExam"));

const AdminResults = lazy(() => import("./pages/Results"));
const EvaluateResults = lazy(() => import("./pages/EvaluateResults"));

const Settings = lazy(() => import("./pages/settings"));

function App() {
  return (
    <CustomThemeProvider>
      <AuthProvider> {/* Wrap with AuthProvider */}
        <Router>
          <Suspense fallback={<PageSkeleton />}>
            <Routes>
              <Route path="/" element={<AuthRoute><Home /></AuthRoute>} />

              {/* Auth */}
              <Route path="/auth/sign-in" element={<AuthRoute><SignIn /></AuthRoute>} />
              <Route path="/auth/forgot-password" element={<ForgotPassword />} />
              <Route path="/auth/reset-password" element={<ResetPassword />} />
              <Route path="/auth/verify-email" element={<VerifyEmail />} />
              
              <Route path="/admin/question-papers/create" element={<ProtectedRoute><CreateQuestionPaper/></ProtectedRoute>}/>
              <Route path="/admin/question-papers/edit/:paperId" element={<ProtectedRoute><EditQuestionPaper/></ProtectedRoute>}/>
              <Route path="/admin/question-papers" element={<ProtectedRoute><QuestionPapers/></ProtectedRoute>}/>
            
              {/* User */}
              <Route path="/admin/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/admin/user-control" element={<ProtectedRoute><UserControl /></ProtectedRoute>} />
              <Route path="/admin/exams" element={<ProtectedRoute><ExamControl /></ProtectedRoute>} />
              <Route path="/admin/exams/create" element={<ProtectedRoute><AdminCreateExam /></ProtectedRoute>} />
              <Route path="/admin/exams/edit/:examId" element={<ProtectedRoute><AdminEditExam /></ProtectedRoute>} />
              <Route path="/admin/exams/:examId" element={<ProtectedRoute><AdminExamDetails /></ProtectedRoute>} />
              
              <Route path="/admin/results" element={<ProtectedRoute><AdminResults /></ProtectedRoute>} />
              <Route path="/admin/results/:resultId" element={<ProtectedRoute><AdminResults /></ProtectedRoute>} />
              <Route path="/admin/evaluate/:examId/:studentId" element={<ProtectedRoute><EvaluateResults/></ProtectedRoute>}/>

              <Route path="/admin/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/admin/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </Router>
      </AuthProvider>
    </CustomThemeProvider>
  );
}

export default App;